import { Directive, Input, OnChanges, OnInit } from "@angular/core";
import { ElementRef } from "@angular/core";

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: "[spinnerButton]",
})
export class SpinnerButtonDirective implements OnInit, OnChanges {
    @Input("spinnerButton") isWaiting: boolean;
    originalInnerText: string;
    originalInnerHTML: string;
    originalElement: any;
    constructor(private el: ElementRef) {}

    ngOnInit() {
        this.originalInnerText = this.el.nativeElement.innerText;
        this.originalInnerHTML = this.el.nativeElement.innerHTML;
        const flag = this.el.nativeElement;
        this.originalElement = flag;
        console.log("on init", flag);

        console.log("on init", this.originalElement);
    }

    ngOnChanges() {
        // console.log(this.originalInnerText);
        // console.log('inside spinner button ');
        // console.log('nativeElement.value : ' + this.el.nativeElement.value);
        // console.log('nativeElement : ' + this.el.nativeElement);
        console.log("on change", this.originalElement);

        if (this.isWaiting) {
            this.el.nativeElement.innerHTML =
                '<i style="font-size:21px" class="fa fa-refresh fa-spin"></i>';
        } else {
            if (
                this.el.nativeElement.innerHTML ===
                '<i style="font-size:21px" class="fa fa-refresh fa-spin"></i>'
            ) {
                this.el.nativeElement = this.originalElement;
            }
        }
        this.el.nativeElement.disabled = this.isWaiting;
    }
}
